import React from "react";
import { LicenseInfo } from "@mui/x-license";

import "typeface-lato";
import "./index.css";
import "./i18n";

import DateLocalizationWrapper from "DateLocalizationWrapper";
import { createRoot } from "react-dom/client";
import Root from "Root";
import GlobalStyles from "@mui/material/GlobalStyles";
import { StyledEngineProvider } from "@mui/material/styles";

import { getSentryReactConfig, initializeSentry } from "./sentry";

initializeSentry();
// set MUI license key
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

const root = createRoot(
  document.getElementById("root") as HTMLElement,
  getSentryReactConfig()
);

root.render(
  <React.StrictMode>
    <DateLocalizationWrapper>
      <StyledEngineProvider enableCssLayer>
        <GlobalStyles styles="@layer theme, base, components, utilities, mui; " />
        <Root />
      </StyledEngineProvider>
    </DateLocalizationWrapper>
  </React.StrictMode>
);
